import { ChatInterface } from "../../common/components/ChatInterface";

export const ChatPage = () => {
  return (
    <div className="chat-page-container">
      <ChatInterface />
    </div>
  );
}